export const vehicleInventoryTransform = (vehicle) => {
    const {
        vehicle: {
            configurationId,
            certified,
            demo,
            make: { name: make },
            model: { name: model },
            modelTrimCode,
            newVehicle,
            odometer,
            paymentOptions,
            paymentOptions: { disclaimer: disclaimerGeneral },
            serialNo: vin,
            stockNo: stockNumber,
            showroomVehicleId,
            vehicleId,
            year,
        },
    } = vehicle

    return {
        vehicle: {
            configurationId,
            certified,
            demo,
            disclaimerGeneral,
            make,
            model,
            modelTrimCode,
            newVehicle,
            odometer,
            showroomVehicleId,
            stockNumber,
            vehicleId,
            vin,
            year,
            paymentOptions,
        },
        paymentOptions,
    }
}

export const vehicleCatalogTransform = (vehicle) => {
    const {
        vehicleTrim: {
            year,
            make: { name: make },
            model: { name: model },
            bodyStyle: { slug: bodyStyle },
            paymentOptions,
        },
    } = vehicle

    return {
        vehicleTrim: {
            year,
            make,
            model,
            bodyStyle,
        },
        paymentOptions,
    }
}
